import React from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";

const NavBar = () => {
  return (
    <div>
      <Navbar expand="lg" className="bg-body-tertiary">
        <Container fluid>
          <Navbar.Brand as={Link} to="/home">
            <img
              src="https://ayg.s3.us-east-2.amazonaws.com/dhanamlogo.png"
              alt="Logo"
              className="img-fluid"
              style={{ height: "50px" }}
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link as={Link} className="fw-bold" to="/home">
                Home
              </Nav.Link>
              <Nav.Link as={Link} className="fw-bold" to="/about-us">
                About Us
              </Nav.Link>
              <Nav.Link as={Link} className="fw-bold" to="/services">
                Solutions
              </Nav.Link>
              <Nav.Link as={Link} className="fw-bold" to="/contact-us">
                Contact Us
              </Nav.Link>
              {/* <Nav.Link as={Link} className="fw-bold" to="/register">
                Register
              </Nav.Link>
              <Nav.Link as={Link} className="fw-bold" to="/sign-in">
                Sign In
              </Nav.Link> */}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
};

export default NavBar;
